var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6875 0H9.08086C9.42813 0 9.76172 0.139453 10.0078 0.385547L11.8645 2.24219C12.1105 2.48828 12.25 2.82188 12.25 3.16914V9.1875C12.25 9.91211 11.6621 10.5 10.9375 10.5H5.6875C4.96289 10.5 4.375 9.91211 4.375 9.1875V1.3125C4.375 0.587891 4.96289 0 5.6875 0ZM1.3125 3.5H3.5V5.25H1.75V12.25H7V11.375H8.75V12.6875C8.75 13.4121 8.16211 14 7.4375 14H1.3125C0.587891 14 0 13.4121 0 12.6875V4.8125C0 4.08789 0.587891 3.5 1.3125 3.5Z",
    fill: "#303A46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.ec125159246630c091950406b29892cb.svg";
export { ForwardRef as ReactComponent };